export const ADD_DS_PL = 'ADD_DS_PL';
export const DEL_DS_PL = 'DEL_DS_PL';
export const DEL_ALLDS_PL = 'DEL_ALLDS_PL';
export const CHANGE_DS_PL = 'CHANGE_DS_PL';
export const CHANGE_SELROW_PL = 'CHANGE_SELROW_PL';
export const ISDEL_PL = 'ISDEL_PL';

export function addDsAction(ID) {
    return {
        type: ADD_DS_PL,
        ID: ID
    };
}

export function delDsAction(rowID) {
    return {
        type: DEL_DS_PL,
        rowID: rowID
    };
}

export function delAllDsAction() {
    return {
        type: DEL_ALLDS_PL
    };
}

export function changeDsAction(ds) {
    return {
        type: CHANGE_DS_PL,
        ds: ds
    };
}

export function changeSelRowAction(rowID) {
    return {
        type: CHANGE_SELROW_PL,
        rowID: rowID
    };
}

export function isDelAction(isDel) {
    return {
        type: ISDEL_PL,
        isDel: isDel
    };
}